import * as api from 'services/api';
import { addError } from 'actions/error';

export const getReferralKey = () => (dispatch) =>
  api.get('referral-program', 'GET_REF_KEY', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_REF_KEY_ERROR')));
    return error;
  });

export const createReferralKey = () => (dispatch) =>
  api.post('referral-program/create', {}, 'CREATE_REF_KEY', dispatch).catch((error) => {
    dispatch(addError(new Error('CREATE_REF_KEY_ERROR')));
    return error;
  });

export const setReferralKey = (referralCode) => (dispatch) =>
  api.post('referral-program/use', { referralCode }, 'SET_REF_KEY', dispatch).catch((error) => {
    dispatch(addError(new Error('SET_REF_KEY_ERROR')));
    return error;
  });
